import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { getScoreLevel } from './getScoreLevel';
import useStyles from './VariationScore.styles';
import { Loader } from 'components/Loader';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  classes?: {};
  score: number;
  loading?: boolean;
}

export const VariationScore = ({ classes, score, loading }: Props) => {
  const clamp = (num: number, lower: number, upper: number) => {
    num = num <= upper ? num : upper;
    num = num >= lower ? num : lower;
    return num;
  };

  const preparedScore = clamp(score, 0, 100);
  const scoreLevel = getScoreLevel(preparedScore);

  const styles = useStyles({ classes, scoreLevel });

  return (
    <div className={styles.root}>
      <CircularProgress
        classes={{ root: styles.circleBg_root, circle: styles.circleBg_circle }}
        size={30}
        variant="static"
        value={100}
      />

      {loading ? (
        <Loader className={styles.Loader} />
      ) : (
        <div className={styles.ScoreContainer}>
          <CircularProgress
            classes={{ root: styles.circle_root, circle: styles.circle_circle }}
            size={30}
            variant="static"
            value={preparedScore}
          />

          <span className={styles.score}>{preparedScore}</span>
        </div>
      )}
    </div>
  );
};
